import { GridApi } from 'ag-grid-community'
import { RefObject, useRef } from 'react'
import { useOnClickOutside } from 'view/hooks'

export function useStopEditingOnClickOutsideGrid<T extends HTMLElement>({
  api,
  gridElRef
}: {
  api: GridApi | null | undefined
  gridElRef: RefObject<T>
}) {
  const menuPortalRef = useRef<HTMLElement | null>(document.getElementById('MenuContainerPortal'))

  useOnClickOutside({
    ref: [gridElRef, menuPortalRef],
    handler: () => {
      api?.stopEditing()
    }
  })
}
